import { gql } from '@apollo/client';

/**
 * SYM-6351. What the editor needs about the campaign's job title and location, its notices, and
 * which ads are live or out of date -- one answer from the server (include=campaignValues), so the
 * campaign lists never pay for it. Read whole: the shape is CampaignValuesState in
 * utils/campaignValues.ts.
 */
export const GET_CAMPAIGN_VALUES = gql`
  query getCampaignValues($vacancyId: ID!) {
    campaignValuesState(id: $vacancyId)
      @rest(
        type: "CampaignValuesState"
        path: "/v4/vacancies/{args.id}?include=campaignValues"
      ) {
      id
      campaignValues
    }
  }
`;

/** SYM-6351, scene 14. The staff-only Ad history panel (the server refuses anyone else). */
export const GET_AD_VERSIONS = gql`
  query getAdVersions($vacancyId: ID!) {
    adVersions(id: $vacancyId)
      @rest(type: "AdVersions", path: "/v4/vacancies/{args.id}/ad-versions") {
      timezone
      timezone_known
      ads
    }
  }
`;
